module.exports = __webpack_public_path__ + "img/20.691f5806.jpg";